module.exports = __webpack_public_path__ + "img/brigitte-michael.19f7b55b.jpg";